import React, { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "../../../../style/dispatchOverview.css";
import { apiAxios } from "../../../../utils/apiAxios";
import { Order } from "../Interfaces/DispatchOverview";
// Columns
const deliveryColumns: TableColumn<any>[] = [
  { name: "Delivery Boy", selector: row => row.userName, sortable: true },
  { name: "Total Orders", selector: row => row.totalCount },
  { name: "In Transit", selector: row => row.transitCount },
  { name: "Delivered", selector: row => row.deliveredCount },
  { name: "Pending", selector: row => row.pendingCount },
];

const orderColumns: TableColumn<Order>[] = [
  { name: "Order ID", selector: row => row.id },

  {
    name: "Pickup",
    selector: row => row.pickup|| "—",
    wrap: true   // optional (for long address)
  },
  { name: "PickupTime", selector: row => row.pickupTime },

  {
    name: "Drop",
    selector: row => row.drop|| "—",
    wrap: true   // optional
  },
  { name: "DropTime", selector: row => row.dropTime },

  {
    name: "Status",
    cell: row => {
      let color = "black";
      if (row.status === "Delivered") color = "green";
      else if (row.status === "In Transit") color = "orange";
      else if (row.status === "Pending") color = "red";
      return <span style={{ color, fontWeight: "bold" }}>{row.status}</span>;
    }
  },

  { name: "Last Update", selector: row => row.lastUpdate },
];

const DispatchOverview: React.FC = () => {
  const [selectedBoy, setSelectedBoy] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);

  const handleRowClick = async (row: any) => {
    try {
      setSelectedBoy(row);
      setShowModal(true);

      const res = await apiAxios.get(
        `Central/orders-by-delivery-user?userId=${row.userID}`
      );
      if (res.data?.isSuccess) {

        // 🔥 MAPPING HERE
        const formattedOrders = (res.data.data || []).map((item: any) => ({
          id: item.orderID,
          pickup: item.millingHubAddress,
          millingHubAddress: item.millingHubAddress,
          drop: item.clinicAddress,
          route: `${item.millingHubAddress} → ${item.clinicAddress}`,
          status: item.status,
          pickupTime: item.pickupTime
            ? new Date(item.pickupTime).toLocaleString("en-IN", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
              day: "2-digit",
              month: "short"
            })
            : "Not Picked",
          dropTime: item.dropTime
            ? new Date(item.dropTime).toLocaleString("en-IN", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
              day: "2-digit",
              month: "short"
            })
            : "Not Delivered",
          lastUpdate: new Date(item.lastUpdate).toLocaleString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            day: "2-digit",
            month: "short"
          })
        }));

        setOrders(formattedOrders);
      }

    } catch (err) {
      console.error(err);
    }
  };


  const fetchDeliverySummary = async () => {
    try {
      setLoading(true);
      const res = await apiAxios.get("Central/delivery-user-summary");

      if (res.data?.isSuccess) {
        setData(res.data.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeliverySummary();
  }, []);

  const totalOrders = data.reduce((s, d) => s + d.totalCount, 0);
  const totalTransit = data.reduce((s, d) => s + d.transitCount, 0);
  const totalDelivered = data.reduce((s, d) => s + d.deliveredCount, 0);
  const totalPending = data.reduce((s, d) => s + d.pendingCount, 0);


  return (
    <div className="dispatch-dashboard">

      <h4 className="mb-4">Dispatch Overview</h4>

      {/* ✅ KPI CARDS */}
      <div className="stats-grid mt-2">

        <div className="stat-box2">
          <h2 className="stat-number">{totalOrders}</h2>
          <div className="stat-label blue">
            <i className="bi bi-bag-fill"></i> Total Orders
          </div>
        </div>

        <div className="stat-box2">
          <h2 className="stat-number">{totalTransit}</h2>
          <div className="stat-label yellow">
            <i className="bi bi-truck"></i> In Transit
          </div>
        </div>

        <div className="stat-box2">
          <h2 className="stat-number">{totalDelivered}</h2>
          <div className="stat-label green">
            <i className="bi bi-check-circle-fill"></i> Delivered
          </div>
        </div>

        <div className="stat-box2">
          <h2 className="stat-number">{totalPending}</h2>
          <div className="stat-label red">
            <i className="bi bi-clock-fill"></i> Pending
          </div>
        </div>

      </div>
      {/* ✅ TABLE */}
      <div className="premium-card mt-5">
        <DataTable
          columns={deliveryColumns}
          data={data}
          highlightOnHover
          pointerOnHover
          pagination
          onRowClicked={handleRowClick}
          className="admin-delivery-table"
        />
      </div>

      {/* ✅ MODAL */}
      {showModal && selectedBoy && (
        <div className="modal-overlay">
          <div className="modal-content premium-modal">
            <div className="d-flex justify-content-between">
              <h5>{selectedBoy.userName} - Order Tracking</h5>
              <button
                className="custom-close-btn btn-close "
                onClick={() => setShowModal(false)}
              >
                <i className="bi bi-x customcross"></i>
              </button>
            </div>


            <div className="modal-scroll">
              <DataTable
                columns={orderColumns}
                data={orders}
                pagination
                highlightOnHover
              />
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default DispatchOverview;